import React, { useEffect, useState } from 'react'
import { useHistory, useParams } from 'react-router-dom'
import { useDispatch } from 'react-redux'
import { useForm, Controller } from 'react-hook-form'
import { Panel, Form, Message, Row } from 'rsuite'
import SaveButton from '../../components/buttons/saveButton/SaveButton'
import ReviewSummaryResultForm from '../../components/forms/reviewSummaryForm/ReviewSummaryResultForm'
import ReviewSummaryForm from '../../components/forms/reviewSummaryForm/ReviewSummaryForm'
import {
  saveReviewSummary,
  saveDraftReviewSummary,
  deleteFile,
  getSchemaReviewSummary,
} from '../../redux/actions/reviewSummary'
import { getScrutinizeAttachmentMulti } from '../../redux/actions/scrutinize'
import { startLoading, doneLoading } from '../../utils/loading'
import ExpertResultListTable from '../../components/table/expertResultListTable/expertResultListTable'
import ApprovedExpertListTable from '../../components/table/approvedExpertListTable/ApprovedExpertListTable'
import pathname from '../../constants/pathname'
import ConfirmWidget from '../confirm/ConfirmWidget'
import { getValueFromOptions } from '../../utils/dataUtil'
import { downloadFile, previewFile } from '../../utils/fileUtil'

export default function ReviewSummaryResult({ schema, onComplete, isMulti }) {
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState(false)
  const [isShowConfirm, setIsShowConfirm] = useState(false)
  const [isShowConfirmDraft, setIsShowConfirmDraft] = useState(false)
  const dispatch = useDispatch()
  const { register, handleSubmit, errors, control, setValue, getValues, setError, clearErrors } =
    useForm()
  const [formSchema, setFormSchema] = useState(schema)
  const [confirmDetail, setConfirmDetail] = useState(schema)
  const [errorMsg, setErrorMsg] = useState()
  const [isDeleteError, setIsDeleteError] = useState(false)
  const [isRefreshSchema, setIsRefreshSchema] = useState(false)

  const [isEnableSubmit, setIsEnableSubmit] = useState(false)
  const [alertMessage, setIsAlertMessage] = useState()

  //const projectId = useSelector((state) => state.getParameter?.projectId)
  const projectId = sessionStorage.getItem('projectId')
  const history = useHistory()

  useEffect(() => { 
    if(schema){
      setIsEnableSubmit(schema?.ValidateResult?.enableSubmit)
      setIsAlertMessage(schema?.ValidateResult?.message)
    }
  }, [schema])

  const handleSaveReviewSummary = async (request, reviewerFilter) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    try {
      const _schema = await saveReviewSummary(request)

      if (typeof onComplete === 'function') {
        onComplete(_schema)
      } else {
        doneLoading()
        const _projectVersionId =
          _schema.projectVersionId || _schema.model?.projectVersionId || projectId

        // if (request.reviewerFilter.value == 1 || request.reviewerFilter.value == 2) {
        sessionStorage.setItem('projectId', _projectVersionId)
        sessionStorage.setItem('param', '')

        if (reviewerFilter == 1 || reviewerFilter == 2) {
          return history.push(`${pathname.proposal.review.proposalRevise}`)
        }
        return history.push(`${pathname.proposal.overview.overviewCoworker}`)
      }
    } catch (e) {
      setIsError(true)
    }
    setIsLoading(false)
    doneLoading()
  }

  const handleRequest = (data, type) => {
    console.log('data ', data)

    const formData = new FormData()

    data.file &&
      data.file?.forEach((element) => {
        formData.append('files', element.blobFile)
      })

    formData.append(
      'projectVersionId',
      isMulti ? formSchema.ReviewerSummary.projectVersionId : projectId
    )
    formData.append('isMulti', isMulti || false)

   
    if(data.reviewFormList) {
      const reviewFormValuesList = [];
     Object.entries(data.reviewFormList).forEach(([key, value]) => {
        const [masterSubjectId, projectFeedbackId] = key.split('_');
        reviewFormValuesList.push({
            projectFeedbackId: projectFeedbackId || null,
            masterSubjectId: masterSubjectId,
            value: value
        });
    });
      
      reviewFormValuesList?.forEach((element, index) => {
        console.log('element ', element)
        formData.append(`reviewFormList[${index}].id`, element.masterSubjectId)
        formData.append(`reviewFormList[${index}].projectFeedbackId`, element.projectFeedbackId || '')
        formData.append(`reviewFormList[${index}].value`, element.value)
      })
    }

    // //#region background
    // formData.append('background.id', formSchema.ReviewerSummary?.background?.id || '')
    // formData.append(
    //   'background.projectFeedbackId',
    //   formSchema.ReviewerSummary?.background?.projectFeedbackId || ''
    // )
    // formData.append('background.value', data.background || '')
    // //#endregion background

    // //#region objective
    // formData.append('objective.id', formSchema.ReviewerSummary?.objective?.id || '')
    // formData.append(
    //   'objective.projectFeedbackId',
    //   formSchema.ReviewerSummary?.objective?.projectFeedbackId || ''
    // )
    // formData.append('objective.value', data.objective || '')
    // //#endregion objective

    // //#region periodAndPlan
    // formData.append('periodAndPlan.id', formSchema.ReviewerSummary?.periodAndPlan?.id || '')
    // formData.append(
    //   'periodAndPlan.projectFeedbackId',
    //   formSchema.ReviewerSummary?.periodAndPlan?.projectFeedbackId || ''
    // )
    // formData.append('periodAndPlan.value', data.periodAndPlan || '')
    // //#endregion periodAndPlan

    // //#region targetGroup
    // formData.append('targetGroup.id', formSchema.ReviewerSummary?.targetGroup?.id || '')
    // formData.append(
    //   'targetGroup.projectFeedbackId',
    //   formSchema.ReviewerSummary?.targetGroup?.projectFeedbackId || ''
    // )
    // formData.append('targetGroup.value', data.targetGroup || '')
    // //#endregion targetGroup

    // //#region budget
    // formData.append('budget.id', formSchema.ReviewerSummary?.budget?.id || '')
    // formData.append(
    //   'budget.projectFeedbackId',
    //   formSchema.ReviewerSummary?.budget?.projectFeedbackId || ''
    // )
    // formData.append('budget.value', data.budget || '')
    // //#endregion budget

    // //#region monitoring
    // formData.append('monitoring.id', formSchema.ReviewerSummary?.monitoring?.id || '')
    // formData.append(
    //   'monitoring.projectFeedbackId',
    //   formSchema.ReviewerSummary?.monitoring?.projectFeedbackId || ''
    // )
    // formData.append('monitoring.value', data.monitoring || '')
    // //#endregion monitoring

    // //#region expectedResult
    // formData.append('expectedResult.id', formSchema.ReviewerSummary?.expectedResult?.id || '')
    // formData.append(
    //   'expectedResult.projectFeedbackId',
    //   formSchema.ReviewerSummary?.expectedResult?.projectFeedbackId || ''
    // )
    // formData.append('expectedResult.value', data.expectedResult || '')
    // //#endregion expectedResult

    // //#region otherComment
    // formData.append('otherComment.id', formSchema.ReviewerSummary?.otherComment?.id || '')
    // formData.append(
    //   'otherComment.projectFeedbackId',
    //   formSchema.ReviewerSummary?.otherComment?.projectFeedbackId || ''
    // )
    // formData.append('otherComment.value', data.otherComment || '')
    // //#endregion otherComment

    //#region reviewResult
    formData.append('reviewResult.value', data.reviewResult || '')
    //#endregion reviewResult

    //#region summarizeReviewResult
    formData.append('summarizeReviewResult.value', data.summarizeReviewResult || '')
    //#endregion summarizeReviewResult

    //#region reviewerFilter
    formData.append('reviewerFilter.value', data.reviewerFilter)
    //#endregion reviewerFilter

    if (type === 'saveDraft') {
      // handleSaveDraft(body)
      handleSaveDraft(formData)
    } else {
      // handleSaveReviewSummary(body)
      handleSaveReviewSummary(formData, data.reviewerFilter)
    }

    //#region old request body
    // console.log('type ', type)
    // const body = {
    //   projectVersionId: isMulti ? formSchema.ReviewerSummary.projectVersionId : projectId,
    //   isMulti: isMulti || false,
    //   background: {
    //     id: formSchema.ReviewerSummary?.background?.id,
    //     projectFeedbackId: formSchema.ReviewerSummary?.background?.projectFeedbackId,
    //     value: data.background,
    //   },
    //   objective: {
    //     id: formSchema.ReviewerSummary?.objective?.id,
    //     projectFeedbackId: formSchema.ReviewerSummary?.objective?.projectFeedbackId,
    //     value: data.objective,
    //   },
    //   periodAndPlan: {
    //     id: formSchema.ReviewerSummary?.periodAndPlan?.id,
    //     projectFeedbackId: formSchema.ReviewerSummary?.periodAndPlan?.projectFeedbackId,
    //     value: data.periodAndPlan,
    //   },
    //   targetGroup: {
    //     id: formSchema.ReviewerSummary?.targetGroup?.id,
    //     projectFeedbackId: formSchema.ReviewerSummary?.targetGroup?.projectFeedbackId,
    //     value: data.targetGroup,
    //   },
    //   budget: {
    //     id: formSchema.ReviewerSummary?.budget?.id,
    //     projectFeedbackId: formSchema.ReviewerSummary?.budget?.projectFeedbackId,
    //     value: data.budget,
    //   },
    //   monitoring: {
    //     id: formSchema.ReviewerSummary?.monitoring?.id,
    //     projectFeedbackId: formSchema.ReviewerSummary?.monitoring?.projectFeedbackId,
    //     value: data.monitoring,
    //   },
    //   expectedResult: {
    //     id: formSchema.ReviewerSummary?.expectedResult?.id,
    //     projectFeedbackId: formSchema.ReviewerSummary?.expectedResult?.projectFeedbackId,
    //     value: data.expectedResult,
    //   },
    //   otherComment: {
    //     id: formSchema.ReviewerSummary?.otherComment?.id,
    //     projectFeedbackId: formSchema.ReviewerSummary?.otherComment?.projectFeedbackId,
    //     value: data.otherComment,
    //   },
    //   reviewResult: {
    //     value: data.reviewResult,
    //   },
    //   reviewerFilter: {
    //     value: data.reviewerFilter,
    //   },
    // }
    //#endregion old request body
  }

  const onSubmit = (data) => {
    var _confirmDetail = getValueFromOptions(
      formSchema.ReviewerSummary?.reviewerFilter?.options,
      data.reviewerFilter
    )

    if (data.reviewerFilter === 0) {
      //if value = 0 ; find label by this way
      var _option = formSchema.ReviewerSummary?.reviewerFilter?.options.filter(
        (item) => item.value === 0
      )
      _confirmDetail = _option[0].label
    }

    setConfirmDetail(_confirmDetail)
    setIsShowConfirm(true)
  }

  const onConfirm = (data) => {
    setIsShowConfirm(false)
    handleRequest(data)
  }

  const onCancle = () => {
    setIsShowConfirm(false)
  }

  const onSubmitDraft = () => {
    setIsShowConfirmDraft(true)
    const valueDraft = getValues()
    clearFromErrors(valueDraft)
    // handleSaveDraft(valueDraft)
  }

  const clearFromErrors = (values) => {
    for (const key in values) {
      clearErrors(key)
    }
  }

  const onCancleDraft = () => {
    setIsShowConfirmDraft(false)
  }

  const onConfirmDraft = () => {
    const valueDraft = getValues()
    // console.log('valueDraft => ', valueDraft)
    handleRequest(valueDraft, 'saveDraft')
  }

  const handleSaveDraft = async (request) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)
    setIsShowConfirmDraft(false)

    try {
      const res = await saveDraftReviewSummary(request)

      if (res.success) {
        handelSetErrorMsg('success', 'บันทึกร่างผลการพิจารณากลั่นกรองสำเร็จ')
        setTimeout(() => refreshSchema(), 1000)
      } else {
        handelSetErrorMsg('error')
      }
    } catch (e) {
      setIsError(true)
      handelSetErrorMsg('error', e.response.data.errors?.message)
    }

    setIsLoading(false)
    doneLoading()
  }

  const handelSetErrorMsg = (type, description) => {
    let desc = description ? description : `ไม่สามารถทำรายการได้ กรุณาลองใหม่หรือติดต่อผู้ดูแลระบบ`
    setErrorMsg({ type, description: desc })
    setTimeout(() => setErrorMsg(null), 5000)
  }

  const handleDeleteFile = async (fileId) => {
    console.log('handleDeleteFile ', fileId)
    startLoading()
    setIsLoading(true)
    setIsError(false)
    setIsDeleteError()

    try {
      const status = await deleteFile(projectId, fileId)

      if (status === 200) {
        setIsDeleteError(false)
        refreshSchema()
      } else {
        setIsDeleteError(true)
      }
    } catch (e) {
      console.log('error : ', e)
      setIsDeleteError(true)
    }

    setIsLoading(false)
    doneLoading()
  }

  const refreshSchema = async () => {
    try {
      const res = await getSchemaReviewSummary(projectId)

      if (res.model.forms) {
        setIsRefreshSchema(true)
        setFormSchema(res.model.forms)
      }
    } catch (e) {
      console.log('error : ', e)
    }
    setTimeout(() => setIsRefreshSchema(false), 1000)
  }

  const handlePreviewFile = async (fileObj) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)

    try {
      const file = await getScrutinizeAttachmentMulti(projectId, fileObj.id)
      console.log('deleteFile ', file)

      if (file) {
        previewFile(file, fileObj.name)
      }
    } catch (e) {
      console.log('error : ', e)
    }

    setIsLoading(false)
    doneLoading()
  }

  const handleDownloadFile = async (fileObj) => {
    startLoading()
    setIsLoading(true)
    setIsError(false)

    try {
      const file = await getScrutinizeAttachmentMulti(projectId, fileObj.id)

      if (file) {
        downloadFile(file, fileObj.name)
      }
    } catch (e) {
      console.log('error : ', e)
    }

    setIsLoading(false)
    doneLoading()
  }

  return (
    <>
      <Form fluid>
        <Panel shaded header="" bordered collapsible defaultExpanded>
          <ApprovedExpertListTable
            data={formSchema.ReviewerApproveList?.itemsList}
            hideRound={true}
            //hideInviteLetter={true}
            setIsEnableSubmit={setIsEnableSubmit}
            setIsAlertMessage={setIsAlertMessage}
            enableEdit={true}
          />
        </Panel>
        <br />

        {formSchema?.ReviewerSummary &&
        <>
        <Panel shaded header="" bordered collapsible defaultExpanded>
          <ReviewSummaryResultForm
            schema={formSchema.ReviewerSummary}
            disableTableFiles={false}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
            getValues={getValues}
          />
        </Panel>
        <br />
        <Panel
          shaded
          header={formSchema.ReviewerSummary.reviewResult.label}
          bordered
          collapsible
          defaultExpanded
        >
          <ReviewSummaryForm
            schema={formSchema.ReviewerSummary}
            register={register}
            Controller={Controller}
            control={control}
            errors={errors}
            setValue={setValue}
            clearErrors={clearErrors}
            onDelete={handleDeleteFile}
            isDeleteError={isDeleteError}
            onPreview={handlePreviewFile}
            onDownload={handleDownloadFile}
            isRefreshSchema={isRefreshSchema}
          />
          <hr />
          {isError && (
            <Row style={{ marginBottom: 10 }}>
              <Message
                showIcon
                type="error"
                description={'เกิดข้อผิดพลาดในการบันทึก กรุณาลองใหม่อีกครั้งหรือติดต่อผู้ดูแลระบบ'}
              />
            </Row>
          )}

          {errorMsg && (
            <Message
              showIcon
              type={errorMsg.type}
              description={errorMsg.description}
              style={{ marginBottom: 20 }}
            />
          )}

          {alertMessage && (
            <Message
              showIcon
              type={"warning"}
              description={alertMessage}
              style={{ marginBottom: 20 }}
            />
          )}

          <SaveButton
            onClick={handleSubmit(onSubmit)}
            disabled={isLoading || schema?.reviewerFilter?.disabled || !isEnableSubmit}
          >
            บันทึกผลการพิจารณากลั่นกรอง
          </SaveButton>

          <SaveButton
            onClick={onSubmitDraft}
            disabled={isLoading || schema?.reviewerFilter?.disabled}
          >
            บันทึกร่างผลการพิจารณากลั่นกรอง
          </SaveButton>
        </Panel>
        </>}

        <br />
      </Form>

      <ConfirmWidget
        title={`ยืนยันการบันทึกผลการพิจารณากลั่นกรอง`}
        show={isShowConfirm}
        detail={`กรุณายืนยัน` + confirmDetail}
        onCancle={onCancle}
        onConfirm={handleSubmit(onConfirm)}
      />

      <ConfirmWidget
        title={`ยืนยัน`}
        show={isShowConfirmDraft}
        detail={`ยืนยันการบันทึกร่างผลการพิจารณากลั่นกรอง`}
        onCancle={onCancleDraft}
        onConfirm={onConfirmDraft}
      />
    </>
  )
}
